module.exports = __webpack_public_path__ + "img/flavor8.feb06239.svg";